/* Black Friday bundle: Kaching prices every widget bundle on its own and leaves loose pairs out of it, so 2 + 1 or 2 + 2 pairs get too little discount.
   When the cart holds a widget bundle, every other pair of glasses joins that bundle. Accessories stay out. Loaded only during the BF and CM phases. */
(function () {
  'use strict';

  var PROP = '__kaching_bundles';
  var TYPES = { 'Sunglasses': 1, 'Blue Light Glasses': 1, 'Running Sunglasses': 1, 'Ski Goggles': 1 };
  var busy = false;
  var again = false;
  var nativeFetch = window.fetch;

  function bundleOf(item) {
    try { return JSON.parse(item.properties[PROP]); } catch (e) { return null; }
  }

  function getCart() {
    return nativeFetch(theme.routes.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // The property the widget itself gives to an added pair; built from the main line when the bundle only has that one.
  function memberProp(pairs) {
    var first = null;
    var member = null;
    pairs.forEach(function (item) {
      var b = bundleOf(item);
      if (!b) return;
      if (!first) first = b;
      if (!member && b.id === first.id && b.collectionBreaksProduct) member = item.properties[PROP];
    });
    if (!first) return null;
    return {
      id: first.id,
      value: member || JSON.stringify({ id: first.id, deal: first.deal, v: first.v, collectionBreaksProduct: true })
    };
  }

  function nextLine(pairs, target) {
    return pairs.filter(function (item) {
      var b = bundleOf(item);
      return !b || b.id !== target.id;
    })[0];
  }

  function moveLine(item, target) {
    var properties = {};
    Object.keys(item.properties || {}).forEach(function (k) { properties[k] = item.properties[k]; });
    properties[PROP] = target.value;
    return nativeFetch(theme.routes.cart + '/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: properties })
    }).then(function (r) { if (!r.ok) throw new Error('cart change ' + r.status); });
  }

  // Line keys change with every edit, so the cart is read again for each line.
  function step(moved) {
    return getCart().then(function (cart) {
      var pairs = cart.items.filter(function (item) { return TYPES[item.product_type]; });
      var target = memberProp(pairs);
      var line = target && nextLine(pairs, target);
      if (!line) return moved;
      return moveLine(line, target).then(function () { return step(true); });
    });
  }

  function run() {
    if (busy) { again = true; return; }
    busy = true;
    step(false).then(function (moved) {
      busy = false;
      if (moved) document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
      if (again) { again = false; run(); }
    }).catch(function () { busy = false; again = false; });
  }

  // Not the theme's cart events: the drawer re-renders the upsell form that fires them, so they never reach the document.
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var request = nativeFetch.apply(window, arguments);
    if (/\/cart\/(add|change|update)/.test(url)) {
      request.then(function (r) { if (r.ok) run(); }).catch(function () {});
    }
    return request;
  };
  run();
})();
